import AXIOS from '@/axios-instance';
import Axios from 'axios';

export default {
  retrieveChecklists() {
    return AXIOS.get("/checklist");
  },
  addChecklist(data, schema){
    const config = { headers: {'Content-Type': 'application/json'} };
    return AXIOS.post("/checklist", {
      name:data.title,
      description: data.description,
      creator: "",
      mod1surveyId: data.connectedSurvey,
      listSchema: JSON.stringify(schema)
    }, config);
  },
  getListById(id){
    return AXIOS.get("/checklist/"+id);
  },
  updateChecklist(id, schema){
    const config = { headers: {'Content-Type': 'application/json'} };
    return AXIOS.post("/checklist/"+id, JSON.stringify(schema), config);
  },
  deleteChecklistById(id){
    return AXIOS.delete("/checklist/"+id);
  },
  updateConnectedSurvey(listId, surveyId, mod){
    const config = { headers: {'Content-Type': 'application/json'} };
    return AXIOS.post("/checklist/survey/module/"+mod+"/"+listId, surveyId, config);
  }
}